import { string, object, array, number, lazy } from '@gogame/schemas';

import {
  APPS_FLYER_PROVIDER,
  MY_TRACKER_PROVIDER,
} from 'scenes/Influencers/MasterCampaigns/constants';

import {
  PERIOD,
  APPLICATION,
  NETWORK,
  PLATFORMS,
  BRIEFS,
  TOTAL_BUDGET,
  COST_MODEL,
  AGENCIES,
  AGENCY,
  BUDGET,
  MY_TRACKER_TOKEN,
  ATTRIBUTION_PROVIDER_ID,
} from './constants';

const agenciesSchema = object({
  [AGENCY]: string().required('Agency is required'),
  [BUDGET]: number()
    .positive('Must be more than 0')
    .required('Budget is required'),
});

const getAgenciesValidationSchema = (providerId) => {
  switch (providerId) {
    case APPS_FLYER_PROVIDER:
      return agenciesSchema;
    case MY_TRACKER_PROVIDER:
      return agenciesSchema.shape({
        [MY_TRACKER_TOKEN]: string().required('Tracking token is required'),
      });
    default:
      return agenciesSchema;
  }
};

export const MasterCampaignFormValidationSchema = object({
  [ATTRIBUTION_PROVIDER_ID]: number(),
  [PERIOD]: string().required('Period is required'),
  [APPLICATION]: string().required('Application is required'),
  [NETWORK]: string().required('Network is required'),
  [PLATFORMS]: array(string()).required('Platforms is required'),
  [BRIEFS]: array(string()).required('Briefs is required'),
  [TOTAL_BUDGET]: number()
    .positive('Must be more than 0')
    .required('Total budget is required'),
  [COST_MODEL]: array(string()).required('Cost models is required'),
  [AGENCIES]: array(
    lazy((value = {}) =>
      getAgenciesValidationSchema(
        value[ATTRIBUTION_PROVIDER_ID],
        value[NETWORK]
      )
    )
  ).required('Agencies are required'),
});
